var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{attrs:{"type":"primary","loading":_vm.loading},on:{"click":_vm.getOXml}},[_vm._v(" get OXML ")])}
var staticRenderFns = []

export { render, staticRenderFns }